import { useDispatch, useSelector } from "react-redux";
import cms from "../../../constants/cmskeys";
import {
  changeIsCheckedMobile,
  changeMobile,
} from "../../../redux/Slices/MobileSlice";
import cmsParser from "../../Services/CMSParser";

const Mobile = ({ cmsLabels }) => {
  const dispatch = useDispatch();
  const { mobile, isCheckedMobile } = useSelector((state) => state.mobile);

  return (
    <div className="dds__py-2 dds__border-top">
      <div className="dds__checkbox" role="checkbox">
        <label className="dds__checkbox__label dds__w-100" htmlFor="lrMobileCheck">
          <input
            className="dds__checkbox__input"
            type="checkbox"
            name="lrMobileCheck"
            id="lrMobileCheck"
            value="lg"
            onChange={() => dispatch(changeIsCheckedMobile(!isCheckedMobile))}
          />
          <span tabIndex="-1">{cmsParser(cms.Mobile, cmsLabels)}</span>
        </label>
      </div>
      <div
        className={
          "dds__py-4 dds__px-5 dds__d-none " +
          (isCheckedMobile ? "dds__d-block" : "dds__d-none")
        }
      >
        <div className="dds__row">
          <div className="dds__col--lg-8 dds__col--xl-6">
            <div className="dds__input-text__container dds__row dds__align-items-center dds__py-2">
              <div className="dds__col--md-4 dds__text-md-right">
                <label id="lblLRMobile" htmlFor="txtLRMobile">
                  {cmsParser(cms.Mobile_Number, cmsLabels)}
                </label>
              </div>
              <div className="dds__col--md-8">
                <div className="dds__input-text__wrapper dds__flex-grow-1 dds__pl-md-2">
                  <input
                    type="text"
                    className="dds__input-text"
                    maxLength="30"
                    name="txtLRMobile"
                    id="txtLRMobile"
                    required=""
                    aria-labelledby="lblLRMobile"
                    onChange={(e) => dispatch(changeMobile(e.target.value))}
                    value={mobile}
                  />
                  <div
                    id="sample-input-feedback"
                    className="dds__invalid-feedback"
                  >
                     {cmsParser(cms.validation_mobile, cmsLabels)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mobile;
